import styled from 'styled-components';

const Container = styled.div`
  max-width: 1440px;
  padding: 30px 60px 60px;
  margin: 0 auto;

  ${({ theme }) => `
    ${theme.devices.touch} {
      padding: 20px;
    }
  `}
`;

export default Container;
